import React from "react";
import { styled } from "@material-ui/styles";
import { IPlayer } from "../../types";
import Link from "../link";
import { injectIntl } from "react-intl";
import messages from "./PageViewPlayer.intl";
import { IStyledArguments } from "../../types/styled-arguments";

const Row = styled("div")({
  fontSize: "0.75rem",
});

const Crumb = styled(Link)(({ theme }: IStyledArguments) => ({
  color: theme.palette.text.secondary,
  fontWeight: 500,
  textDecoration: "none",
}));

const Separator = styled("span")({
  color: "#C7CFCD",
  margin: "0 4px",
});

const Current = styled("span")(({ theme }: IStyledArguments) => ({
  color: theme.palette.text.primary,
  fontWeight: 600,
}));

const Breadcrumb = injectIntl<{ player: IPlayer }>(({ player, intl }) => (
  <Row>
    <Crumb to="/">{intl.formatMessage(messages.team)}</Crumb>
    <Separator>/</Separator>
    <Crumb to="/people/players">{intl.formatMessage(messages.players)}</Crumb>
    <Separator>/</Separator>
    <Current>
      {player.name} {player.surname}
    </Current>
  </Row>
));

export default Breadcrumb;
